import { Tooltip } from "@evergis/ui";
import { TooltipContent, TooltipLabel } from "components/Dialogs/EditResource/components/Table/styled";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { TempLayerBadgeContainer } from "./styled";

export const TempLayerBadge: FC = () => {
  const { t } = useTranslation("layerList");

  return (
    <Tooltip
      arrow
      content={
        <div>
          <TooltipLabel>{t("tempLayer")}</TooltipLabel>
          <TooltipContent>{t("tempLayerInstruction")}</TooltipContent>
        </div>
      }
    >
      {ref => <TempLayerBadgeContainer ref={ref}>TMP</TempLayerBadgeContainer>}
    </Tooltip>
  );
};
